export default __webpack_public_path__ + "static/media/pokemonslider.8fe19919.webp";